// extracted by mini-css-extract-plugin
module.exports = {"container":"KsStatus_container__39Jyl","to_pay":"KsStatus_to_pay__1yxaF","marker":"KsStatus_marker__3iCLB","todo":"KsStatus_todo__MEXez","paid":"KsStatus_paid__12Utk"};